import React from "react";
import './input.css';
import Moment from 'moment';

const Input = props => {
  let inputElement = null;

  
  switch (props.elementType) {
    case "input":

    let inputValue = props.value?props.value:"";
    // console.log("inputValue=", props.value);
    if (props.elementConfig.type === 'date') {
      inputValue = Moment(props.value).format("YYYY-MM-DD");
      // console.log("new input value:", inputValue);
    }

    inputElement = <input {...props.elementConfig} value={inputValue} onChange={props.changed} />;
      break;
    case "select":
      inputElement = <select {...props.elementConfig} value={props.value} onChange={props.changed}>
       {props.elementConfig.options.map(option =>{
           return (<option key={option.value} value={option.value}>{option.title}</option>)
       })}
      </select>;
      break;
    default:
      inputElement = <input {...props.elementConfig} value={props.value} onChange={props.changed} />;
  }

  const description = props.description ? <div className="description">{props.description}</div>: null;

  return (
    <div className="Input">
      <label>{props.label}</label>
      {description}
      {inputElement}
    </div>
  );
};

export default Input;
